<div class="not-found" *ngIf="noSuchTopic">
  <br />
  <br />

  <h1>404</h1>

  <ng-container *ngIf="recommendedTopic">
    <div class="info-note dym">
      <label>Did you mean?</label>
      <br />

      <a class="dym-topic-card" routerLink="/topics/{{recommendedTopic.slug}}">
        <div class="image" [responsiveBackgroundImage]="recommendedTopic.thumbnail_square"></div>
        <div>
          {{recommendedTopic.name}}<br />
          <code>tyt.com/topics/{{recommendedTopic.slug}}</code>
        </div>
      </a>
    </div>
  </ng-container>
</div>
<ng-container *ngIf="!noSuchTopic">
  <app-spinner *ngIf="!ready"></app-spinner>

  <tyt-hero-banner *ngIf="isUTMCampaign && !isMember" [icon]="'/assets/svgs/heart.svg'"
    [message]="'By becoming a member, you allow us to continue bringing you stories like these that are important to you. Become a member now and join our community of progressive activists.'"
    [button]="'Become a member'" [url]="getPurchaseUrl()">
  </tyt-hero-banner>

  <div class="page-container" *ngIf="ready">

    <div class="hero" [responsiveBackgroundImage]="topic.backdrop_image || topic.thumbnail_square">
    </div>

    <div class="gradient"></div>
    <div class="content-container">
      <div class="title-line">
        <h1 class="title">{{topic.name}}</h1>
        <div class="action-buttons">
          <a (click)="unfollow()" href="javascript:;" *ngIf="isFollowed">
            <mat-icon>star</mat-icon>
            Unfollow
          </a>
          <a (click)="follow()" href="javascript:;" *ngIf="!isFollowed">
            <mat-icon>star</mat-icon>
            Follow
          </a>
        </div>
      </div>
      <div class="description" *ngIf="topic.description">
        <div [innerHTML]="topic.description | markdownToHtml | trustHtml">

        </div>
      </div>
      <div class="actions-container">
        <div class="spacer">

        </div>
        <a class="all-topics" routerLink="/topics">
          <mat-icon>folder</mat-icon>
          All Topics
        </a>
      </div>
      <div class="content">
        <ng-container *ngIf="!items">
          <div style="flex-grow: 1; width: 100%;">
            <app-spinner></app-spinner>
          </div>
        </ng-container>

        <ng-container *ngIf="items">
          <tyt-topic-feed-item *ngFor="let item of items" [topic]="topic" [audienceType]="audienceType"
            [topicItem]="item"></tyt-topic-feed-item>
        </ng-container>
      </div>
      <tyt-pager [total]="total" [page]="page" [size]="size" (changePage)="goToPage($event)"></tyt-pager>

      <tyt-comments *ngIf="spotIdentifier" [identifier]="spotIdentifier" [shareTitle]="topic.name"></tyt-comments>

    </div>
  </div>
</ng-container>